export enum AgmsResponseCode {
  OK = 0,
  WRONG_TOKEN = 1,
  NO_AUTHORIZE_REQUEST = 2,
  OUT_OF_MONEY = 3,
  OPERATION_IS_NOT_POSSIBLE = 4,
  INTERNAL_ERROR = 5,
  VOUCHER_IS_PAID = 6,
  VOUCHER_INVALID_AMOUNT = 7,
  VOUCHER_DUPLICATED_KEY = 8,
  WRONG_REQUEST_PARAMETERS = 9,
  VOUCHER_HAS_EXPIRED = 10,
  DUPLICATE_SHELL_TRANSACTION = 11,
  LOCATION_NOT_ACTIVE = 12,
  DUPLICATE_WALLET_TRANSACTION = 13,
  DUPLICATE_TICKET_STATE = 15,
  VOUCHER_DAILY_LIMIT_REACHED = 16,
  CONTINUE = 100,
}